import { Sparkles } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { useAiAssistantStore } from '@/stores/aiAssistantStore';
import { useFeature } from '@/contexts/FeatureFlagContext';

/** Header button that opens the Ask ActiveID drawer. Also bound to Ctrl/Cmd+K. */
export function AskAssistantLauncher() {
  const { t } = useTranslation('ai');
  const open = useAiAssistantStore((s) => s.open);
  const aiEnabled = useFeature('ai');

  if (!aiEnabled) return null; // hidden when AI is off for this tenant/deployment

  return (
    <Button variant="outline" size="sm" onClick={open} className="gap-2" title="Ctrl/⌘ + K">
      <Sparkles className="h-4 w-4 text-primary" />
      <span className="hidden sm:inline">{t('title')}</span>
    </Button>
  );
}
